var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaieStricte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 439.4160583941606,
    viewBox: "0, 0, 400,439.4160583941606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M66.800 219.600 L 66.800 439.200 100.200 439.200 L 133.600 439.200 133.600 219.600 L 133.600 0.000 100.200 0.000 L 66.800 0.000 66.800 219.600 M200.400 219.600 L 200.400 439.200 233.400 439.200 L 266.400 439.200 266.400 219.600 L 266.400 0.000 233.400 0.000 L 200.400 0.000 200.400 219.600 M333.200 219.600 L 333.200 439.200 366.600 439.200 L 400.000 439.200 400.000 219.600 L 400.000 0.000 366.600 0.000 L 333.200 0.000 333.200 219.600 ",
    stroke: "none",
    fill: "#fcfcc4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M0.000 219.600 L 0.000 439.200 33.400 439.200 L 66.800 439.200 66.800 219.600 L 66.800 0.000 33.400 0.000 L 0.000 0.000 0.000 219.600 M133.600 219.600 L 133.600 439.200 167.000 439.200 L 200.400 439.200 200.400 219.600 L 200.400 0.000 167.000 0.000 L 133.600 0.000 133.600 219.600 M266.400 219.600 L 266.400 439.200 299.800 439.200 L 333.200 439.200 333.200 219.600 L 333.200 0.000 299.800 0.000 L 266.400 0.000 266.400 219.600 ",
    stroke: "none",
    fill: "#040404",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaieStricte);
export default __webpack_public_path__ + "static/media/haie-stricte.f02fdc6c4769efd91b0a6e06b1abef9e.svg";
export { ForwardRef as ReactComponent };